var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 25.5h-15A2.5 2.5 0 0 1 0 23V3A2.5 2.5 0 0 1 2.5.5h8.75c.014 0 .027.003.04.007a.188.188 0 0 0 .038.008c.11.007.219.028.323.064l.035.011a1.235 1.235 0 0 1 .449.285l7.5 7.5c.105.106.19.23.25.366.012.028.021.056.031.085l.011.033c.035.104.056.212.062.322a.197.197 0 0 0 .008.034.158.158 0 0 1 .003.035V23a2.5 2.5 0 0 1-2.5 2.5ZM2.5 3v20h15V10.5h-6.25c-.69 0-1.25-.56-1.25-1.25V3H2.5Zm10 1.768V8h3.232L12.5 4.768Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.a97897613d13dcdc99b8f0b7b5ced1af.svg";
export { ForwardRef as ReactComponent };